export default __webpack_public_path__ + "static/media/atatürk.5832eee5.gif";